import { DragDropItem } from '../../drag-drop/types/item';
import { SchedulerItemOnMachine } from './item-on-machine';

export abstract class SchedulerBaseItem extends DragDropItem {
  abstract get id(): number;
  // abstract get itemsOnMachine(): SchedulerItemOnMachine[];
  // abstract set itemsOnMachine(value: SchedulerItemOnMachine[]);
  // abstract get workOrderId(): number;
  abstract get title(): string;
  abstract get priority(): boolean;
  abstract set priority(val: boolean);
  abstract readonly TYPE: string;
  protected __rank = '1|z';
  get rank(): string {
    return this.__rank;
  }
  set rank(value: string) {
    this.__rank = value;
  }
  get rankNumber(): number {
    return this.__rankNumber;
  }
  set rankNumber(value: number) {
    this.__rankNumber = value;
  }

  // abstract getItemOnMachineByMachineId(
  //   machineId: number
  // ): SchedulerItemOnMachine | undefined;
  //
  // abstract factoryItemOnMachine(
  //   itemOnMachine?: SchedulerItemOnMachine
  // ): SchedulerItemOnMachine;
}

export abstract class SchedulerItem extends SchedulerBaseItem {
  abstract get itemsOnMachine(): SchedulerItemOnMachine[];
  abstract set itemsOnMachine(value: SchedulerItemOnMachine[]);
  abstract get workOrderId(): number;
  abstract getItemOnMachineByMachineId(
    machineId: number
  ): SchedulerItemOnMachine | undefined;
  batchNumber: number;

  abstract factoryItemOnMachine(
    itemOnMachine?: SchedulerItemOnMachine
  ): SchedulerItemOnMachine;
}
